'use strict';

function ContourPreviewService () {

  let site = null;
  let dataCapture = null;
  let uuid = null;

  this.setData = (data) => {

    site = data.site;
    dataCapture = data.dataCapture;
    uuid = data.uuid;
  };

  this.setSite = (_site) => {

    site = _site;
  };

  this.setDataCapture = (_dataCapture) => {

    dataCapture = _dataCapture;
  };

  this.setUuid = (_uuid) => {

    uuid = _uuid;
  };

  this.getData = () => {

    return {
      site,
      dataCapture,
      uuid
    };
  };

  this.getSite = () => site;

  this.getDataCapture = () => dataCapture;

  this.getUuid = () => uuid;
}

ContourPreviewService.$inject = [];

module.exports = ContourPreviewService;



// WEBPACK FOOTER //
// ./src/app/shared/contourPreview/ContourPreviewService.js